import { MainNavProps } from "./navigation/main/MainParamList";
import { Platform, Pressable, StyleSheet, Text, View } from "react-native";
import {
  color_333333,
  color_main,
  ColorC5EAE1,
  white,
} from "../assets/style/colors";
import React, { useEffect, useMemo, useRef, useState } from "react";
import QRCode from "react-native-qrcode-svg";
import { LeftView } from "./Chat/CListItem";
import {
    Str_QRCodeError,
} from "../language/string_res";
import { getUserName } from "./Chat/chat-helper";
import * as ImSdk from "../../imsdk/api";
import BackIcon from "../assets/svg/ic_left_arrow_white.svg";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useIsFocused } from "@react-navigation/native";

// Web 版本：移除权限检查函数
export async function hasAndroidPermission() {
  console.warn("hasAndroidPermission not supported on web");
  return false;
}

export function QRCodeScreen({
  navigation,
  route,
}: MainNavProps<"QRCodeScreen">) {
  const [group, setGroup] = useState(route.params.group);
  const [user, setUser] = useState(route.params.user);
  const insets = useSafeAreaInsets();
  const isFocused = useIsFocused();
  const { avatar, name, qrcode_desc, qrcode, isGroup } = useMemo(() => {
    const avatar = group?.avatar || user?.avatar;
    const name = group?.remark || group?.name || getUserName(user);
    const qrcode_desc = group?.qrcode_desc || user?.qrcode_desc;
    const qrcode = group?.qrcode || user?.qrcode;
    let isGroup = false;
    if (group) {
      isGroup = true;
    }

    return { avatar, name, qrcode_desc, qrcode, isGroup };
  }, [user, group]);

  useEffect(() => {
    if (!isFocused) {
      return;
    }

    const im = ImSdk.getInstance();
    if (group) {
      im.GetGroupRemote(group.tid).then((r) => {
        if (r.group) {
          setGroup(r.group);
        }
      });
    }
    if (user) {
      im.GetUserRemote(user.uid).then((r) => {
        if (r.users && r.users.length > 0) {
          setUser(r.users[0]);
        }
      });
    }
  }, [isFocused]);

  return (
    <View
      style={{ flex: 1, backgroundColor: ColorC5EAE1, flexDirection: "column" }}
    >
      <Pressable
        style={{
          width: 44,
          height: 44,
          marginTop: insets.top,
          alignItems: "center",
          justifyContent: "center",
        }}
        onPress={() => {
          navigation.pop();
        }}
      >
        <BackIcon width={20} height={20} />
      </Pressable>

      <View
        style={{
          backgroundColor: white,
          borderRadius: 20,
          alignItems: "center",
          paddingBottom: 4,
          paddingHorizontal: 30,
          marginTop: 60,
          marginHorizontal: 13,
        }}
      >
        <View style={{ marginTop: -50, paddingStart: 12 }}>
          <LeftView
            left={{ name: name, avatar: avatar, uid: user?.uid || 0 }}
            size={100}
            isRounded={true}
            isGroup={isGroup}
          />
        </View>
        <Text
          numberOfLines={2}
          ellipsizeMode={"tail"}
          style={{
            color: "black",
            fontSize: 16,
            textAlign: "center",
            width: "100%",
            marginBottom: 16,
            marginTop: 6,
          }}
        >
          {name}
        </Text>

        {qrcode && qrcode.length > 0 ? (
          <View style={{ backgroundColor: white, padding: 12 }}>
            <View
              style={{
                width: 220,
                height: 220,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <QRCode
                value={qrcode}
                size={220}
                // 不传 logo，保留二维码清晰
              />
              {/* 居中覆盖：使用 Image 或直接渲染文字 SVG */}
              <View
                style={{
                  position: "absolute",
                  width: 30,
                  height: 30,
                  borderRadius: 15,
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "transparent", // 或 color_main 做为底色
                }}
              >
                <LeftView
                  left={{ name: getUserName(user), avatar: user?.avatar, uid: 0 }}
                  size={30}
                  isRounded={true}
                />
              </View>
            </View>
          </View>
        ) : (
          <Text style={{ width: 220, height: 220, color: color_333333 }}>
            {Str_QRCodeError}
          </Text>
        )}
        <Text
          style={{
            marginTop: 18,
            color: "#888888",
            marginHorizontal: 30,
            textAlign: "center",
            textAlignVertical: "center",
            fontSize: 14,
          }}
        >
          {qrcode_desc}
        </Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  dashLine: {
    flexDirection: "row",
    marginTop: 24,
    marginBottom: 32,
  },
});
